import { DeleteOutline } from '@mui/icons-material';
import { Autocomplete, Button, Chip, IconButton, TableCell, TableRow, TextField } from '@mui/material';
import { format } from 'date-fns';
import { Formik } from 'formik';
import { t } from 'i18next';
import { useState } from 'react';
import { deleteAPIKey, postAPIKey } from 'src/api/stoApi';
import { NewAPIKeyDialog } from 'src/components/assets/dialogs/NewAPIKeyDialog';
import { LaunchpadTable } from 'src/components/mui-overrides/LaunchpadTable';
import { DefaultTextField } from 'src/components/mui-overrides/Textfield';
import { useAPIKeys } from 'src/hooks/useAPIKeys';
import { array, object, string } from 'yup';

export const PartnerMainPage = () => {
  const [reload, setReload] = useState(false);
  const [openNewAPIKeyDialog, setOpenNewAPIKeyDialog] = useState(false);
  const apikeys = useAPIKeys(reload);
  const [newAPIKey, setNewAPIKey] = useState('');

  const validationSchema = object({
    name: string().required().trim(),
    ipAddresses: array().min(1).of(string().required().trim()),
  });

  return (
    <>
      <NewAPIKeyDialog
        apikey={newAPIKey}
        open={openNewAPIKeyDialog}
        onClose={() => {
          setOpenNewAPIKeyDialog(false);
          setNewAPIKey('');
        }}
      />
      <Formik
        initialValues={{
          name: '',
          ipAddresses: [],
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, formik) => {
          console.log(values);
          const response = await postAPIKey(values);
          setNewAPIKey(response.data.data.apiKey);
          setOpenNewAPIKeyDialog(true);
          formik.resetForm();
          setReload(!reload);
        }}
        validateOnMount
      >
        {(props) => {
          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 20,
                gap: 10,
              }}
            >
              <DefaultTextField
                hideHelperText
                margin={'none'}
                formik={props}
                label={t('dashboard.partner.apikey.form.name')}
                fieldName={'name'}
              ></DefaultTextField>
              <Autocomplete
                style={{ width: '33%' }}
                multiple
                freeSolo
                renderTags={(value: any, getTagProps) =>
                  value.map((option: string, index: number) => <Chip variant="outlined" label={option} {...getTagProps({ index })} />)
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={props.touched.ipAddresses && !!props.errors.ipAddresses}
                    fullWidth
                    variant="outlined"
                    label={t('dashboard.partner.apikey.form.ipaddresses')}
                    placeholder="0.0.0.0"
                  />
                )}
                options={[]}
                disableClearable
                filterSelectedOptions
                {...props.getFieldProps('ipAddresses')}
                onChange={(event, option: string[]) => {
                  const valOnly = option.map((o) => o ?? o);
                  props.setFieldValue('ipAddresses', [...valOnly]);
                }}
              />
              <Button
                variant="contained"
                disableElevation
                color="primary"
                onClick={() => props.submitForm()}
                style={{ width: 150, height: 50 }}
              >
                {t('dashboard.partner.apikey.form.submit')}
              </Button>
            </div>
          );
        }}
      </Formik>
      <LaunchpadTable
        hidePagination={true}
        length={apikeys?.length || 0}
        renderHeader={() => {
          return (
            <TableRow>
              <TableCell>{t('dashboard.partner.apikey.table.name')}</TableCell>
              <TableCell>{t('dashboard.partner.apikey.table.ipaddresses')}</TableCell>
              <TableCell>{t('dashboard.partner.apikey.table.createdAt')}</TableCell>
              <TableCell style={{ width: 50 }}></TableCell>
            </TableRow>
          );
        }}
        renderRows={() => {
          return (
            <>
              {apikeys?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.ipAddresses.join(', ')}</TableCell>
                  <TableCell>{format(new Date(row.createdAt), 'dd.MM.yyyy')}</TableCell>
                  <TableCell>
                    {
                      <IconButton
                        onClick={async () => {
                          await deleteAPIKey(row.id);
                          setReload(!reload);
                        }}
                      >
                        <DeleteOutline />
                      </IconButton>
                    }
                  </TableCell>
                </TableRow>
              ))}
            </>
          );
        }}
      />
    </>
  );
};
